import React, { useEffect, useState } from "react";
import notice1 from '../media/Notices/AGM Notice 1.pdf';
import notice1pic from '../media/Notices/notice1.png';
import notice2 from '../media/Notices/AGM notice 2.pdf';
import notice2pic from '../media/Notices/notice2.png';
import arthiknews from '../media/Notices/arthiknews.png';
import sharesansar from '../media/Notices/sharesansarnotice.png';
import merolagani from '../media/Notices/merolagani.png';
import axios from "axios";
import { Card } from "antd";
import config from '../config.json';
// import apiKey from "../apikey.json";


const NoticeBoard = () => {

    const [notices, setNotices] = useState([])

    const getNotice = async () => {
        try {
            const response = await axios.post(
                config.prodURL + "notices",
                {
                    headers: {
                        // "API-Key": apiKey.DJANGO_API_KEY,
                        "Content-Type": "application/json",
                    },
                }
            );
          
            setNotices(JSON.parse(response.data))


        } catch (error) {
            console.error("Error:", error);
        }
    }


    useEffect(() => {
        getNotice();
    }, []);



    return (
        <div className="about-container">
            <div className="content">
                <h1>Media and Notice</h1>

                {notices.map((notice: any, index) => (

                    <a key={index}
                        href={notice.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", display: "flex", justifyContent: 'center' }}
                    >
                        <Card
                            hoverable
                            style={{
                                width: 720,
                                borderRadius: 12,
                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
                                transition: "all 0.3s ease-in-out",
                                margin: 10
                            }}
                            cover={
                                <img
                                    alt="Attachment"
                                    src={notice.attachment}
                                    style={{
                                        height: 180,
                                        objectFit: "cover",
                                        borderTopLeftRadius: 12,
                                        borderTopRightRadius: 12,
                                    }}
                                />
                            }
                        >
                            <h3 style={{ marginBottom: 4, fontSize: "1.2rem", fontWeight: 600, color: "#333" }}>
                                {notice.name}
                            </h3>
                            <p style={{ marginBottom: 6, fontSize: "0.85rem", color: "#888" }}>{notice.created_at}</p>
                            <p style={{ fontSize: "0.95rem", color: "#444" }}>{notice.description}</p>
                        </Card>
                    </a>
                ))}

                <object data={notice1} type="application/pdf" width="400" height="500">
                    <img src={notice1pic} alt="notice1" width={200} />
                </object>
                <object data={notice2} type="application/pdf" width="400" height="500">
                    <img src={notice2pic} alt="notice2" width={200} />
                </object>

            </div>
        </div>
    )
}


export default NoticeBoard;